export const BillColumnsToSearchById = {
  idNfse: "idNfse",
  idVenda: "idVenda",
  idVendaMtq: "idVendaMtq",
  idNota: "idNota",
}